import { autofillData, autofillData_cachedForm, Campground } from "./type_defs";

export interface tripPlanner_reservation_data {
	legIndex:number;
	stopIndex:number;
	campID:number;
	s_date:Date;
	e_date:Date;
	reservationId:number|string;
};

export class tripPlannerReservationEvent extends Event {
	public data:tripPlanner_reservation_data;

	constructor(data:tripPlanner_reservation_data) {
		super("tp.reservation.created", { bubbles: true });
		this.data = data;
	}
};

export const POI_TYPE_MAP:any = {
	1: "Fitness",
	2: "Other Parks",
	3: "Other Entertainment",
	4: "Golf",
	5: "Historical Sites",
	6: "Amusement Parks",
	7: "Marinas",
	8: "Casinos",
	9: "Zoos & Gardens",
	10: "National Parks",
	11: "State Parks",
	12: "Skiing",
	13: "Arcades",
	22: "Museums",
	24: "National Forests",
	25: "Pilot Flying J Gas",
	26: "Love's Travel Stops Gas",
	27: "TA Travel Center Gas",
	28: "Other Gas",
	29: "GenieTrip Stop",
	30: "Bucees Gas"
};

export type copilot_success_resp = {
	arguments:any;
	name:string;
};
export type copilot_err_resp = {
	found_intent:boolean;
	message:string;
}

export type Campground_Data = {
	camp:Campground;
	amenities:Array<string>;
	activities:Array<string>;
	affiliations:Array<string>;
	connectivity:Array<string>;
	discount:Array<string>;
	paymentMethod:Array<string>;
	dist?:number;//altStops have dist = distance to stop centerpoint

	s_date?:Date;//just for use in selectedCamps array of a Trip_Cluster_v2
	numNights?:number|null;//just for use in selectedCamps array of a Trip_Cluster_v2

	is_fake_camp?:boolean;//for custom stays

	sponsoredEventId?:string;//for altStops if they're in sponsored results set

	datesLocked?:boolean;//dates get locked if user makes reservation for camp
	reservationId?:number|string;
};

export type Trip_Cluster = {
	selectedCamp:Campground_Data;
	altCampIDs:Array<number>;
	altStops:Array<Campground_Data>;
	numNights:number|null;
};

export type POI_Data = {
	name:string;
	id:string;
	poi_typeID:number;
	types:string;
	addr:string;
	icon:string;
	url:string|null;
	loc:{latitude:number,longitude:number};
	street_address:string|null;
	city:string;
	administrative_area_level_1:string;
	date?:Date;
	sidebarHTML?:string;
	info_phone:string|null;
	openRoads_brand:string|null;
	openRoads_poi:boolean|null;
};

export type Trip_Cluster_v2 = {
	geo_query?:string;
	selectedCamps: Array<Campground_Data>;
	POIs:Array<POI_Data>;
	altCampIDs:Array<number>;
	altStops: Array<Campground_Data>;
	s_date?:Date;
	numNights?:number|null;
	coords:{latitude:number,longitude:number};
	radius?:number;
	fromUserQuery:boolean;
	clusterTitle:string;

	hasCustomStay?:boolean;

	notes?:string;
	gotMatchScores?:boolean;
	hideStopPin?:boolean;

	wishes?:string[];

	stopID:string;
};

export type Trip_leg = {
	lockedStops:Array<number>;
	clusters:Array<Trip_Cluster>;
};

export type Trip_leg_v2 = {
	lockedStops:Array<number>;
	clusters:Array<Trip_Cluster_v2>;
};

export type Trip_Filters = {
	driveTime:number;
	driveDist:number;
	routeWidth:number;
	avoidHighways:boolean;
	avoidTolls:boolean;
	avoidFerries:boolean;
	avoidTunnels:boolean;
	//amenities:Array<string>;
	useFullDriveDist:boolean;
	vehicleType:"car"|"rv";
	avoidAreas?:{name:string, id:string, bounds: null|{northeast:{lat:number,lng:number},southwest:{lat:number,lng:number}}}[];
	avoidStates?:string[];
	dist_unit?:string;
};

export type Trip_Filters_cachedForm = {
	d:number;//driveTime
	D:number;//driveDist
	r:number;
	a:boolean;//avoidHighways
	tu:boolean;//avoidTunnels
	f:boolean;//avoidFerries
	to:boolean;//avoidTolls
	//a:Array<string>;
	ufd:boolean;//useFullDriveDist
	vt:"car"|"rv";//vehicleTYpe
	aA?:{name:string, id:string, bounds: {northeast:{lat:number,lng:number},southwest:{lat:number,lng:number}}}[];//avoidAreas
	aS?:string[];//avoidStates
	du?:string;//dist_unit
};

export type Trip = {
	stopListHTML: string;
	queries:Array<string>;
	filters:Trip_Filters;
	legs:Array<Trip_leg>;
	directions:any;
	autoFillData:Array<autofillData>;
	startDate:Date|null;
	lockedLegs:Array<number>;
	name:string;
	desc:string;
	tripID:string|null;
};

export type Trip_v2 = {
	searchQuery?:string;
	itinerary?: string;
	stopListHTML: string;
	queries:Array<string>;
	geo_queries?:Array<string>;//only used for genieTrips - custom titles not geocodable
	filters:Trip_Filters;
	legs:Array<Trip_leg_v2>;
	directions:any;
	autoFillData:Array<autofillData>;
	startDate:Date|null;
	lockedLegs:Array<number>;
	name:string;
	desc:string;
	tripID:string|null;

	failed_auto_add_camps?:boolean;
};

export type Trip_clusterSendUpdateFormat = {
	selectedCamp:number;
	altCampIDs:Array<number>;
};

export type Trip_clusterSendUpdateFormat_v2 = {
	selectedCamps:Array<number>;
	altCampIDs:Array<number>;
	coords:{latitude:number,longitude:number}
};

export type Trip_legSendUpdateFormat_v2 = {
	lockedStops:Array<number>;
	clusters:Array<Trip_clusterSendUpdateFormat_v2>;
};

export type Trip_legSendUpdateFormat = {
	lockedStops:Array<number>;
	clusters:Array<Trip_clusterSendUpdateFormat>
};

export type Trip_legCachedFormat = {
	lockedStops:Array<number>;
	clusterStops: Array<number>
};

export type trip_clusterCachedFormat = {
	c: Array<number>;//coords [longitude,latitude]
	r?:number;//radius
	s: Array<{
		i:number,//campID
		sd?:Date,//s_date
		n?:number//numNights,
		f?:number//is_fake_trip
	}>;//stays
	p:Array<{id:string,d?:Date}>;//pois -- d is date
	u:0|1;//fromUserQuery
	t:string;//clusterTitle
	sd?:Date;//s_date
	n?:number|null;//numNights
	no?:string;//notes
	hp?:boolean;//hideStopPin
	w?:string[];//wishes

	id:string;//stopID
};

export type Trip_legCachedFormat_v2 = {
	l:Array<number>;//lockedStops
	c: Array<trip_clusterCachedFormat>;//clusterStops
}

export type Trip_sendUpdateFormat = {
	queries:Array<string>;
	filters:Trip_Filters;
	autoFillData:Array<autofillData>;
	startDate:Date|null;
	lockedLegs:Array<number>;
	name:string;
	desc:string;
	tripID:string|null;
	legs?: Array<Trip_legSendUpdateFormat>
};

export type Trip_sendUpdateFormat_v2 = {
	queries:Array<string>;
	filters:Trip_Filters;
	autoFillData:Array<autofillData>;
	startDate:Date|null;
	lockedLegs:Array<number>;
	name:string;
	desc:string;
	tripID:string|null;
	legs?: Array<Trip_legSendUpdateFormat_v2>
};

export type Trip_cookieFormat = {
	queries:Array<string>;
	filters:Trip_Filters;
	autoFillData:Array<autofillData>;
	startDate:Date|null;
	lockedLegs:Array<number>;
	name:string;
	desc:string;
	tripID:string|null;
	legs?: Trip_legCachedFormat[]
};

export type Trip_cookieFormat_v2 = {
	sq?:string;//search query
	it?:string;//itinerary
	q:Array<string>;//queries
	g_q?:Array<string>;//geo_queries - only used for genieTrips -- custom titles not geocodable
	f:Trip_Filters_cachedForm;//filters
	a:Array<autofillData_cachedForm>;//autoFillData
	s:Date|null;//startDate
	lL:Array<number>;//lockedLegs
	n:string;//name
	d:string;//desc
	l?: Trip_legCachedFormat_v2[];//legs
	tripID:string|null;
};

export type Trip_sendUpdateGetDirectionsFormat = {
	trip:Trip_sendUpdateFormat;
	coords:Array<Array<number>>;
};

export type Trip_sendUpdateGetDirectionsAndHTMLFormat = {
	trip:Trip_sendUpdateFormat;
	tripLegData: {
		legs:Array<{
			clusters:Array<{
				selectedCamp:Campground_Data;
			}>
		}>
	}
};

export type Trip_sendUpdateGetDirectionsAndHTMLFormat_v2 = {
	trip:Trip_cookieFormat_v2;
	tripLegData: {
		legs:Array<{
			clusters:Array<{
				selectedCamps:Array<Campground_Data>;
			}>
		}>
	},
	showStaySelection:boolean,
	tripID?:string
};

export type cachedTrip_leg = {
	stop:number;
	altCampIDs:Array<number>;
};

export type cachedTrip = {
	stopListHTML: string;
	queries:string;
	filters:Trip_Filters;
	legs:Array<cachedTrip_leg>;
	directions:any;
	autoFillData:autofillData;
	startDate:Date|null;
	lockedLegs:Array<number>;
	name:string;
	desc:string;
	tripID:string|null;
};

export type removeStop_params = {
	legIndex:number;
	stopIndex:number;
	tripStopCoords:Array<Array<number>>;
};

export type removeStop_expectedResponse = {
	directions:any;
};

export type Trip_PlannerResponse_addStopBySearch = {
	newClusters:Array<Trip_Cluster>,
	newClusters_startIndex:number,
	directions:any,
	stopListHTML:string,
};

export type genieTripReq_stop = {
	id:number;
	lat:number;
	lon:number;
	dest_str:string;
};

export type genieTripReq_params = {
	tripID:string;
	stops:Array<genieTripReq_stop>;
	driveTime:number;
	driveDist:number;
	routeWidth:number;
	avoidHighways:number;
	routeStart_query?:string;
	routeStart_query_type?:string;
	routeStart_query_val?:string;
	routeEnd_query?:string;
	routeEnd_query_type?:string;
	routeEnd_query_val?:string;
	isFRVT?:string;
};